module.exports = __webpack_public_path__ + "static/media/printing-services-img10.85be00c7.jpg";